import React from "react"
import S from "./footer.module.scss"
import { Link } from "gatsby"
import SocialWidget from "../Tools/SocialWidget"

const Footer = () => {
  return (
    <footer className={S.footer}>
      <div className={S.columncontainer}>
        <div className={S.column}>
          <Link to="/aboutus" className={S.titles}>
            ABOUT US
          </Link>
          <Link to="/aboutus#block1">who we are</Link>
          <Link to="/aboutus#block2">our jewellery</Link>
          <Link to="/aboutus#block3">responsibility</Link>
          <Link to="/blog">blog</Link>
        </div>

        <div className={S.column}>
          <Link to="/customercare" className={S.titles}>
            CUSTOMER CARE
          </Link>
          <Link to="/login">my account</Link>
          <Link to="/customercare#block1">returns</Link>
          <Link to="/customercare#block2">shipping</Link>
          <Link to="/customercare#block3">faq's</Link>
          <Link to="/customercare#block4">terms & conditions</Link>
        </div>

        <div className={S.column}>
          <Link to="/contact" className={S.titles}>
            CONTACT US
          </Link>
          <Link to="/contact">call us: 0123 456 7891</Link>
          <Link to="/contact">email us</Link>
          <Link to="/feedback">feedback</Link>
          <Link to="/complaints">complaints</Link>
        </div>
      </div>

      <SocialWidget />

      <div className={S.footermessage}>
        © {new Date().getFullYear()}, Stalia London | all rights reserved in
        privacy policy. We do not sell personal information.
      </div>
    </footer>
  )
}

export default Footer
